import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ProductSubNav } from "@/components/portal/ProductSubNav";
import { kbSqlSubNav } from "@/lib/navigationItems";

export const Route = createFileRoute("/portal/knowledgebase-sql")({
  component: KBSqlLayout,
});

function KBSqlLayout() {
  return (
    <div className="space-y-4">
      <ProductSubNav items={kbSqlSubNav} />
      <Outlet />
    </div>
  );
}
